import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { StyleServiceService } from '@app/finxone-web-frontend/app/lib/services/style-service/style-service.service';
import { setCssAttributes } from '@app/finxone-web-frontend/app/lib/utils/utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  BaseWidgetProperties,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  WidgetSection,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Subject } from 'rxjs';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-lottie-animation-widget',
  templateUrl: './lottie-animation-widget.component.html',
  styleUrl: './lottie-animation-widget.component.scss',
})
export class LottieAnimationWidgetComponent extends BaseComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public lottieWidgetProperties: BaseWidgetProperties;
  widgetConfigData: WidgetSection;
  public override contentStyle: baseCssConfigStyle;

  constructor(
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private styleService: StyleServiceService,
    private configService: ConfigService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.dataIn?.attri) {
      this.lottieWidgetProperties = this.dataIn.attri.widgetProperties;
      this.setCssAttributes();
    }
  }

  setCssAttributes() {
    const { baseWidgetStyle } = setCssAttributes(this.styleService, this.configService, this.dataIn?.attri);
    this.contentStyle = baseWidgetStyle;
  }
}
